import React, { useEffect, useState } from "react";
import { useLang } from "../LangContext";
import { useTenant } from "../TenantContext";
import { HashLink } from "../HashLink";
import axios from "axios";
import { ArrowLeft, Calendar, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EventiPage() {
    const { t, lang } = useLang();
    const { slug } = useTenant();
    const [events, setEvents] = useState([]);

    useEffect(() => {
        window.scrollTo({ top: 0 });
        axios.get(`${API}/events`, { params: { borgo: slug } }).then((r) => setEvents(r.data)).catch(() => {});
    }, [slug]);

    return (
        <div className="pt-32 pb-24 px-6 lg:px-10 min-h-screen" data-testid="eventi-page">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-14">
                    <div className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-700 mb-3">
                        {lang === "it" ? "AGENDA" : "AGENDA"}
                    </div>
                    <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-semibold text-stone-900">
                        {t.eventi_page_title}
                    </h1>
                    <p className="mt-4 text-lg text-stone-600">{t.eventi_page_sub}</p>
                </div>

                <div className="space-y-10">
                    {events.map((ev, i) => (
                        <article
                            key={ev.id}
                            className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-8 bg-white border border-stone-200 rounded-3xl overflow-hidden shadow-sm"
                            data-testid={`eventi-page-item-${i}`}
                        >
                            <div className="md:col-span-2 aspect-video md:aspect-auto md:min-h-[280px] overflow-hidden">
                                <img src={ev.image} alt={ev.title} className="w-full h-full object-cover" />
                            </div>
                            <div className="md:col-span-3 p-8 md:p-10">
                                <div className="flex items-center gap-3 text-xs font-semibold text-stone-500 uppercase tracking-wider mb-3">
                                    <Calendar size={14} className="text-emerald-700" />
                                    {ev.date_label}
                                    <span className="w-1 h-1 bg-stone-400 rounded-full" />
                                    <span className="text-emerald-700">{ev.category}</span>
                                </div>
                                <h2 className="font-serif text-3xl md:text-4xl font-semibold text-stone-900 leading-tight mb-4">
                                    {ev.title}
                                </h2>
                                <p className="text-stone-600 leading-relaxed">{ev.body || ev.excerpt}</p>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="text-center mt-16">
                    <HashLink
                        to="/"
                        className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-amber-600 text-white font-semibold hover:bg-amber-700 hover:-translate-y-0.5 transition-all shadow-lg"
                        data-testid="back-home-btn"
                    >
                        <ArrowLeft size={18} />
                        {t.back_home}
                    </HashLink>
                </div>
            </div>
        </div>
    );
}
